import { Container, Row, Col, Card, Button, Form, Badge, Image } from "react-bootstrap";
import { useState } from "react";

export default function ProductDetails() {
  const [quantity, setQuantity] = useState(1);
  const [activeImg, setActiveImg] = useState(0);

  const product = {
    title: "Premium Dog Food",
    price: 1299,
    description:
      "High-protein dog food made with real chicken — supports immunity, bones, and digestion.",
    stock: true,
    images: [
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog1.png?alt=media&token=ca6b5199-0f56-4658-8453-a6048976d82b",
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fcat1.png?alt=media&token=cc8be358-6e1c-4f45-a365-a1b4c2a02bd2",
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog2.png?alt=media&token=bb9a5ff7-ed80-47ca-b2a0-86a4d05bd244",
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog1.png?alt=media&token=ca6b5199-0f56-4658-8453-a6048976d82b",
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fcat1.png?alt=media&token=cc8be358-6e1c-4f45-a365-a1b4c2a02bd2",
      "https://firebasestorage.googleapis.com/v0/b/todo-studio-159af.appspot.com/o/topBanners%2Fdog2.png?alt=media&token=bb9a5ff7-ed80-47ca-b2a0-86a4d05bd244",
     

    ],
    highlights: ["High Protein", "Vet Recommended", "No preservatives"],
  };

  return (
    <Container className="py-4">
      <Row className="g-4">
        {/* LEFT — IMAGE + THUMBNAILS */}
        <Col md={6}>
          <Card className="shadow-sm mb-3">
            <Card.Img src={product.images[activeImg]} />
          </Card>

          <Row xs={4} className="g-2">
            {product.images.map((img, i) => (
              <Col key={i}>
                <Image
                  src={img}
                  thumbnail
                  onClick={() => setActiveImg(i)}
                  style={{
                    cursor: "pointer",
                    border: activeImg === i ? "2px solid #0d6efd" : "1px solid #ddd",
                  }}
                />
              </Col>
            ))}
          </Row>
        </Col>

        {/* RIGHT — DETAILS */}
        <Col md={6}>
          <h3>{product.title}</h3>

          <div className="mb-2">
            {product.stock ? (
              <Badge bg="success">In Stock</Badge>
            ) : (
              <Badge bg="secondary">Out of Stock</Badge>
            )}
          </div>

          <h4 className="text-primary mb-3">₹{product.price}</h4>

          <p>{product.description}</p>

          <ul>
            {product.highlights.map((h, i) => (
              <li key={i}>{h}</li>
            ))}
          </ul>

          <div className="d-flex align-items-center gap-3 my-3">
            <Form.Label className="m-0">Quantity</Form.Label>

            <Form.Select
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              style={{ width: "90px" }}
            >
              {[1, 2, 3, 4, 5].map((n) => (
                <option key={n}>{n}</option>
              ))}
            </Form.Select>
          </div>

          <Button size="lg" disabled={!product.stock}>
            Add to Cart
          </Button>
        </Col>
      </Row>

      {/* EXTRA INFO */}
      <Row className="mt-5">
        <Col>
          <Card className="p-3 shadow-sm">
            <h5>Product Information</h5>
            <p>
              Store in a cool, dry place. Consult your vet before changing diet if your
              pet has allergies or digestive issues.
            </p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
